import { CONNECT_WALLET, DIS_WALLET } from '../actions/walletActions';

const walletReducer = (state = { value: 0, isConnect: false }, action) => {
  switch (action.type) {
    case CONNECT_WALLET:
        return { ...state, value: 1, isConnect: true };
    case DIS_WALLET:
        return { ...state, isConnect: false };
    default:
        return { ...state };
  }
};

export default walletReducer;
